import { AutogenModelEdiStop, AutogenRowEdiStop } from "./autogen/AutogenModelEdiStop";

export class ModelEdiStop extends AutogenModelEdiStop<RowEdiStop> {
    constructor() {
        super(RowEdiStop);
    }
}

export class RowEdiStop extends AutogenRowEdiStop {
}